import {
  IS_BRIDGE_TO_MEDICARE,
  IS_ENROLL,
  IS_LOCAL_ENVIRONMENT,
  PRODUCT_STM
} from 'core/constants/environment'
import initSmartly from 'core/initPage/absmartly'
import getById from 'utils/DOM/getById'
import doRedirect from 'utils/NET/doRedirect'

export function redirectToSTM(isBTMPlan, redirect) {
  if (redirect && isBTMPlan) {
    IS_ENROLL ? doRedirect(`/quotes`) : doRedirect(`/product/${PRODUCT_STM}/quotes`)
  }
}

function forbidBTM(initPageResponse) {
  const smartlySDK = initSmartly()

  if (!smartlySDK) {
    return initPageResponse
  }

  const { search, pathname } = window.location
  const pathParts = pathname.split('/').filter(Boolean)

  const newPath = pathParts.length > 1 ? pathParts.slice(2, pathParts.length) : ['census']
  const variant = smartlySDK.treatment('PH_BTM_REDIRECT')

  if (variant === 1) {
    const optionBTM = getById('toolbar-btm')

    if (optionBTM) {
      optionBTM.remove()
    }

    if (IS_BRIDGE_TO_MEDICARE && !IS_LOCAL_ENVIRONMENT) {
      doRedirect(`/product/${PRODUCT_STM}/${newPath.join('/')}${search}`)
    }
  }

  return initPageResponse
}

export default forbidBTM
